import type {ReactNode} from 'react';

import {TooltipWrapper} from '@/components/ui/tooltip';

type EvacuationDisabledHintProps = {
  reason?: string;
  children: ReactNode;
};

const EvacuationDisabledHint = ({
  reason,
  children,
}: EvacuationDisabledHintProps) =>
  reason ? (
    <TooltipWrapper title={reason}>
      <span className="inline-flex">{children}</span>
    </TooltipWrapper>
  ) : (
    children
  );

export default EvacuationDisabledHint;
